import React from 'react';

const ErrorBoundary = () => {
  return (
    <div>ErrorBoundary</div>
  );
};

export default ErrorBoundary;